import { Button } from "@/components/ui/button";
import { ROUTES } from "@/constants/routes";
import { Globe } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface WebOnlyPageProps {
  title?: string;
  message?: string;
}

/**
 * Shown on native for surfaces intentionally excluded from the iOS app —
 * primarily billing / plan selection / checkout (Apple guideline 3.1.1).
 *
 * Informational only: it deliberately has **no tappable purchase or payment
 * link**, just a pointer to manage things on the web.
 */
export function WebOnlyPage({
  title = "Manage this on the web",
  message = "Billing and plans are handled on the Cohesive website. Visit cohesive.ai in your browser to make changes.",
}: WebOnlyPageProps) {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-dvh w-full flex-col items-center justify-center gap-4 px-6 pb-safe pt-safe text-center">
      <div className="flex size-12 items-center justify-center rounded-full bg-muted">
        <Globe className="size-6 text-muted-foreground" />
      </div>
      <h1 className="text-xl font-semibold text-foreground">{title}</h1>
      <p className="max-w-sm text-sm text-muted-foreground">{message}</p>
      <Button variant="outline" onClick={() => navigate(ROUTES.HOME)}>
        Back to home
      </Button>
    </div>
  );
}

export default WebOnlyPage;
